import { PropType } from 'vue'

export const inputTextDefaultProps = {
  /**
   * 初期選択状態が bind される value
   */
  modelValue: {
    type: String,
    default: '',
  },

  /**
   * フォームの name 属性
   */
  name: {
    type: String,
    default: '',
  },

  /**
   * placeholder テキスト
   */
  placeholder: {
    type: String,
    default: '',
  },

  /**
   * autocomplete 属性に渡す値
   * @see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/autocomplete
   */
  autocomplete: {
    type: String as PropType<AutocompleteAttr>,
    default: 'off',
  },

  /**
   * pattern 属性に渡す値
   * @see https://developer.mozilla.org/ja/docs/Web/HTML/Element/input#pattern
   */
  pattern: {
    type: String,
    default: undefined,
  },

  /**
   * inputmode 属性に渡す値
   * @see https://developer.mozilla.org/ja/docs/Web/HTML/Global_attributes/inputmode
   */
  inputmode: {
    type: String as PropType<'search' | 'text' | 'tel' | 'email' | 'none' | 'url' | 'numeric' | 'decimal' | undefined>,
    default: undefined,
  },

  /**
   * maxlength 属性に付与する最大文字数の数値
   * @description 未指定だと属性自体が付与されない
   */
  maxlength: {
    type: Number,
    default: undefined,
  },

  /**
   * フォームのフォーカスアウト時に前後ホワイトスペースの trim するかどうか
   */
  hasTrim: {
    type: Boolean,
    default: false,
  },

  /**
   * フォームの readonly 属性
   */
  readonly: {
    type: Boolean,
    default: undefined,
  },

  required: {
    type: Boolean,
    default: false,
  },

  /**
   * disabled 属性にわたす非活性フラグ
   */
  isDisabled: {
    type: Boolean,
    default: false,
  },

  /**
   * エラー発生状態かどうか
   * ※ エラー状態は外から受け取る
   */
  isError: {
    type: Boolean,
    default: false,
  },
}
